$(".hidden-text__toggle").click(function () {
    let hiddenText = $(this).siblings(".hidden-text")
    $(hiddenText).toggleClass("_show")
    console.log(hiddenText)
})

fixHeader()
$(window).scroll(function() {
    fixHeader()

    var $sections = $('._anchors-target');
    $sections.each(function(i, el) {
        var top = $(el).offset().top - 50;
        var bottom = top + $(el).height();
        var scroll = $(window).scrollTop();
        var idn = $(el).attr('id');
        if (scroll > top && scroll < bottom) {
            $('.doctor-nav__link').removeClass('_active');
            $('a[href="#' + idn + '"]').addClass('_active');
        }
    });
})


function fixHeader() {
    if ($(window).scrollTop() > 75) {
        $(".fixed-nav").addClass("_bg")
    } else {
        $(".fixed-nav").removeClass("_bg")
    }
}


$(".doctor-nav__link").click(function(event) {
    event.preventDefault();
    var idc = $(this).attr('href'),
        top = $(idc).offset().top;
    $('body,html').animate({ scrollTop: top }, 100);
});


